import { countries } from 'country-data';

export const getCountryName = ({ code }) => {
  return countries[code?.toUpperCase()]?.name;
};
